import React from 'react';
import { rowStyles } from './constants';

const DDTable = ({
  tableHeadings,
  isDataLoading,
  isRemovingDiallers,
  delayDaillersData,
}) => {
  return (
    <div className='tw-flex tw-items-center tw-w-full tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-1 tw-border-solid tw-border-grey-200  tw-overflow-x-auto tw-mt-2'>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-2xl'>
              {tableHeadings?.map((heading, index) => (
                <th
                  key={heading?.key}
                  title={heading?.name}
                  className={`tw-p-3 ${
                    heading?.width
                  } tw-bg-blue-200 tw-text-grey-800 ${
                    index === tableHeadings.length - 1
                      ? 'tw-border-r-0'
                      : 'tw-border-r'
                  } tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-overflow-hidden tw-text-ellipsis tw-leading-snug tw-text-center`}
                >
                  <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                    {heading?.name}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {!isDataLoading && !isRemovingDiallers && (
            <tbody className='tw-bg-white'>
              {delayDaillersData?.map((item, index) => {
                if (!item) return null;
                return (
                  <tr
                    key={`${item[2]?.title}-${index}`}
                    className={
                      index === delayDaillersData.length - 1
                        ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                        : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                    }
                  >
                    <td
                      className={`
                tw-px-4 tw-border-r tw-py-4 tw-border-solid tw-overflow-hidden tw-text-ellipsis tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-whitespace-nowrap tw-transition-all tw-ease-in-out tw-duration-200 tw-relative tw-group ${
                  index === delayDaillersData.length - 1
                    ? 'tw-rounded-bl-xl'
                    : ''
                }
                `}
                    >
                      {item[1]?.title}
                    </td>
                    <td className={`${rowStyles} tw-w-[10px]`}>
                      {item[2]?.title}
                    </td>
                    <td className={`${rowStyles} tw-w-[10px] `}>
                      {item[3]?.title}
                    </td>
                    <td className={`${rowStyles}`}>{item[4]?.title}</td>
                    <td className={`${rowStyles} tw-text-center`}>
                      {item[5]?.title}
                    </td>
                    <td
                      className={
                        index === 2
                          ? 'tw-rounded-br-2xl tw-border-none tw-px-2 tw-py-4'
                          : 'tw-px-2 tw-py-4'
                      }
                    >
                      {item[6]?.title}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default DDTable;
